/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<5776d59e9520a632a2bd0e4e7b1d9c0d>>
 * @relayHash 7477e4cf6bbf2eda4f99202585e62ae2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8ee43031ea79167aae52525c63afe3b09463ba1daec3e09b51141be6a28f2bc1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type conversationModalQuery$variables = Record<PropertyKey, never>;
export type conversationModalQuery$data = {
  readonly me: {
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"ConversationUser">;
    };
  };
};
export type conversationModalQuery = {
  response: conversationModalQuery$data;
  variables: conversationModalQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "conversationModalQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "AuthenticationContext",
          "kind": "LinkedField",
          "name": "me",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationUser"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW",
              "path": "me.user"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "me"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "conversationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "type": "AtlassianAccountUser",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8ee43031ea79167aae52525c63afe3b09463ba1daec3e09b51141be6a28f2bc1",
    "metadata": {},
    "name": "conversationModalQuery",
    "operationKind": "query",
    "text": null
  }
};

(node as any).hash = "2a9d5c41db0ec456545d77cd25e13c43";

export default node;
